import {
	applyPatches as immerApplyPatches,
	produce,
	enablePatches,
} from 'immer'
import { applyPatches as navigationMapApplyPatches } from '@mission.io/navigation-map-client'
import type { JuniorSharedMissionState } from '@mission.io/mission-toolkit'

enablePatches()

type Patch = {
	op: string,
	path?: Array<string>,
	value: mixed,
}

const extensions = {
	nav: <U: JuniorSharedMissionState>(state: U, patch: Patch): U => {
		try {
			return produce(state, (draft: JuniorSharedMissionState) => {
				draft.navigation.data = navigationMapApplyPatches(
					// $FlowFixMe `draft.navigation.data` is defined as mixed to remove the need to include `navigation-map-client` in `mission-toolkit`
					draft.navigation.data,
					patch.value
				)
			})
		} catch (error) {
			console.error('Error updating navigation map')
			console.error(error)
			console.error('Patches which caused the error')
			console.error(patch)
		}
		return state
	},
}

/**
 * applyPatches - same as immer's `applyPatches` function but can handle custom patch types
 *
 * @param  {U: JuniorSharedMissionState} state - the state to apply the patches to
 * @param  {Array<Patch>} patches - the patches to apply
 *
 * @returns U - the state after applying the patches
 */
export function applyPatches<U: JuniorSharedMissionState>(
	state: U,
	patches: Array<Patch>
): U {
	let batch: Array<Patch> = []

	patches.forEach((patch: ?Patch) => {
		if (!patch) {
			return
		}

		if (extensions.hasOwnProperty(patch.op)) {
			if (batch.length) {
				state = immerApplyPatches(state, batch)
				batch = []
			}
			state = extensions[patch.op](state, patch)
			return
		}
		batch.push(patch)
	})

	if (batch.length) {
		state = immerApplyPatches(state, batch)
	}

	return state
}
